module.exports = __webpack_public_path__ + "static/pinkbooties-32e20e7419d007d16b3ae9903fce0a4d.png";